import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BaseSharedService } from '../base-shared/base-shared.service';
import { StatusEnum } from '@core/action/action';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-table-cadastro',
  templateUrl: './table-cadastro.component.html',
  styleUrls: ['./table-cadastro.component.scss']
})
export class TableCadastroComponent extends BaseComponent implements OnInit, AfterViewInit {

  @Output() tabelaItemInativarEvent = new EventEmitter<any>();
  @Output() tabelaItemDeletarEvent = new EventEmitter<any>();
  @Output() tabelaItemAtivarEvent = new EventEmitter<any>();
  @Input() nomeItem!: string;
  @Input() colunas: any[] = [];
  @Input() columnKeys: any[] = [];
  @Input() acaoBtn: any;
  @Input() service: any;
  @Input() rotaEditar!: string;
  @Input() esconderEditar: boolean = false;
  

  constructor(baseSharedService: BaseSharedService) {
    super(baseSharedService)
  }

  ngOnInit(): void {
    
    this.consultarList(undefined, this.service);
  }

  ngAfterViewInit(): void {
    const sub = this.appSharedDataService.buscar$.subscribe(form => {
      if (!this.isFormularioVazio(form)) {
        this.consultarList(form, this.service)
      }
    })
    this.subscription.add(sub);

    const sub2 = this.appSharedDataService.resetar$.subscribe((res: any) => {
      if (res) {
        this.consultarList(undefined, this.service)
      }
    });
    this.subscription.add(sub2);
  }

  buscarDados(reset: boolean = false): void {
    this.searchList(this.service, reset);
  }

  edit(id: number) {
    (this.rotaEditar)
      ? this.router.navigate([this.rotaEditar, id])
      : this.router.navigate(['cadastro', this.nomeItem, 'editar', id]);
  }

  delete(item: any) {
    (this.acaoBtn === AcaoBtnTabelaEnum.Deletar)
      ? this.tabelaItemDeletarEvent.emit(item)
      : this.tabelaItemInativarEvent.emit(item);
  }

  active(item: any) {
    this.tabelaItemAtivarEvent.emit(item)
  }

  isAtivarInativarDeletarBtn(item: any) {
    if (this.acaoBtn) {
      return (item?.statusCapitulo || item?.ativo || !item?.ativo) ? true : false;
    }
    return false;
  }

  acaoAtivarInativarDeletarBtn(item: any) {
    if (item?.statusCapitulo?.id == 1 || item?.ativo || item?.statusFigurante || item?.status) {
      this.delete(item);
    } else {
      this.active(item);
    }
  }

  textoAtivarInativarDeletarBtn(item: any) {
    if (item?.statusCapitulo?.id == 1 || item?.ativo || item?.statusFigurante || item?.status) {
      let text;
      if (this.acaoBtn === AcaoBtnTabelaEnum.Deletar) {
        text = 'Deletar';
      }
      if (this.acaoBtn === AcaoBtnTabelaEnum.Inativar) {
        text = 'Inativar'
      }
      return text;
    } else {
      return 'Ativar'
    }
  }

  iconeAtivarInativarDeletarBtn(item: any) {
    if (item?.statusCapitulo?.id == 1 || item?.ativo || item?.statusFigurante || item?.status) {
      let icon;

      if (this.acaoBtn === AcaoBtnTabelaEnum.Deletar) {
        icon = 'material-symbols--delete-outline';
      }

      if (this.acaoBtn === AcaoBtnTabelaEnum.Inativar) {
        icon = 'ph--eye';
      }

      return icon;
    } else {
      return this.acaoBtn === AcaoBtnTabelaEnum.Deletar ? 'material-symbols--delete-outline' : 'iconamoon--eye-off-light';
    }
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && !Array.isArray(value);
  }

  colorFn(status: string) {
    switch (status) {
      case StatusEnum.Aprovado:
        return 'text-success';
      case StatusEnum.Cancelado:
        return 'text-warning';
      case StatusEnum.Pendente:
      default:
        return 'text-danger';
    }
  }

  isFormularioVazio(form: FormGroup): boolean {
    for (const controlName in form.controls) {
      if (form.controls.hasOwnProperty(controlName)) {
        const control: AbstractControl = form.controls[controlName];
        if (control.value) {
          return false;
        }
      }
    }
    return true;
  }

  isBoolean(data: any): boolean {
    return typeof data === 'boolean';
  }

  isDataCadastro(data: any, key: string): boolean {
    const stringDatas = ['dataCadastro', 'dataInicio', 'dataFim'];

    if (stringDatas.includes(key)) {
      return true;
    }

    return typeof data === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(data);
  }
}

export enum AcaoBtnTabelaEnum {
  Inativar = 'inativar',
  Deletar = 'deletar'
}
